import React, {useEffect, useState, useRef, useContext} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import {IProps} from './types';
import * as S from './styles';
import { default as D } from '@assets/themes/dimensions';
import { FilterIcon } from '@assets/icons/filterIcon';
import FilterCheck from '@components/Filter';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';
import {IDSConfig, IBrandDefinition} from '@state/dsconfig/types';

const Filter:React.FC<IProps> = (props) => {
  const{ handleChangeFilter, filters } = useContext(DesignsContext);
  const [showMenu, setShowMenu]= useState(false)
  const [plataforms, setPlataform]= useState([] as any)
  const dispatch = useDispatch();
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const openMenu = useSelector(selectors.open.getOpenMenu);
  const componentRef = useRef(null);

  const handleClick = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if (!ref.contains(e.target) && e.target.id !== 'filterButton' && e.target.id!=='filterIcon'){
          setShowMenu(false);
        }
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [])

  useEffect(() => {
    if(dsConfig){
      let plataforms: any=[]
      dsConfig.designTypes.forEach((item:any)=>{
          item.platforms.forEach((plataform:any)=>plataforms.push(plataform.name))
      })
      setPlataform(plataforms)
    }
    
  }, [dsConfig])

  const handleClickBtnFilter = ()=>setShowMenu(!showMenu);
  const handleChangeFilters = (value:any, type:string, add:boolean) => handleChangeFilter(value, type, add);

  let colWidth='0 0 33.33%';
  let width=!openMenu ? `calc(74vw - ${D.VERTICAL_MENU_WIDTH + D.LOGOUT_WIDTH}px)` : `calc(74vw - ${D.LOGOUT_WIDTH}px)`;

  let marginLeft = '';

  return (
    <>
      <S.FilterContainer>
          <S.ButtonFilter onClick={handleClickBtnFilter} id="filterButton">
              <FilterIcon style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: "5px", marginRight: "14px"}}/>
              Filter
          </S.ButtonFilter>
      </S.FilterContainer>
      {dsConfig&&
        <S.MenuFilter ref={componentRef} margin={marginLeft} style={{
          display: showMenu?'block':'none',
          width: width}}>
          <S.Container >
            <S.List colWidth={colWidth}>
              <S.Label>OEM</S.Label>
              { dsConfig.brands.sort((a, b) => {
                  var textA = a.name.toUpperCase();
                  var textB = b.name.toUpperCase();
                  return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }).map((text:IBrandDefinition, index:number) => 
                    <FilterCheck 
                    key={`oem${index}`}
                    label={text.name} 
                    type="oem" 
                    onChange={handleChangeFilters}
                    checked={filters['oem'].includes(text)}/>
              )}
            </S.List>
            <S.List colWidth={colWidth}>
              <S.Label>Ad Platform</S.Label>
              {plataforms.sort().map((text:string, index:number) => 
                  <FilterCheck 
                  key={`platf${index}`}
                  label={text} 
                  type="platform" onChange={handleChangeFilters}
                  checked={filters['platform'].includes(text)}/>
              )}              
            </S.List>
            <S.List colWidth={colWidth}>
              <S.Label>Offer Type</S.Label>
              {dsConfig.offerTypes.sort().map((text:string, index:number) => 
                  <FilterCheck 
                  key={`of${index}`}
                  label={text} 
                  type="offerType" 
                  onChange={handleChangeFilters}
                  checked={filters['offerType'].includes(text)}/>
              )}
            </S.List>
          </S.Container>
        </S.MenuFilter>
      }
    </>
  );
}

export default Filter;